import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Authorization } from 'src/app/intefaces/authorization';
import { HttpAlertService } from '../../services/http-alert.service';
import { CartService } from 'src/app/services/cart.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  public registerForm: FormGroup;
  public loaderRegistring = false;
  public isLoading2 = false;
  public isRegistered = false;
  public isCodeSend = false;
  public code: string;
  @Input() redirectValidLogin: string;
  @Output() registerEmitter = new EventEmitter<any>();

  constructor(
      private authService: AuthorizationService,
      private fb: FormBuilder,
      private httpAlertService: HttpAlertService,
      private cartService: CartService,
      private translate: TranslateService,
      private router: Router,
    ) { }

  ngOnInit(): void {
    this.initForm();
  }

  private register() {
    this.loaderRegistring = true;

    this.authService.sendVefificationCode(this.registerForm.value).subscribe(data => {
      this.loaderRegistring = false;
      this.isCodeSend = true;
    },
    err => {
      this.loaderRegistring = false;
      if (err.error.data && err.error.data.c_password) {
        this.httpAlertService.error(this.translate.instant('passwords_not_same_error'));
      } else if (err.error.message === 'email_error_not_unique') {
        this.httpAlertService.error(this.translate.instant(err.error.message));
      } else {
        this.httpAlertService.error(err.error.message);
      }
    });
  }

  public verifyCode() {
    this.isLoading2 = true;

    const obj = {
      ...this.registerForm.value,
      verification_code: this.code.trim()
    };

    this.authService.register(obj).subscribe(data => {
      this.isLoading2 = false;
      this.isRegistered = true;

      let response: Authorization = data.data;
      this.authService.setCredential(response);
      // this.httpAlertService.success(data.message);
      this.cartService.storeItemsInDb().then(() => {
        if (this.redirectValidLogin) {
          this.registerEmitter.next({ success: true });
          this.router.navigate([this.redirectValidLogin]);
        }
      });
    },
    err => {
      this.isLoading2 = false;
      this.httpAlertService.error(this.translate.instant(err.error.message));
    });
  }

  public onRegister() {
    if (this.registerForm.valid) {
      this.register();
    }
  }


  private initForm() {
    this.registerForm = this.fb.group({
      login: ['', Validators.required],
      password: ['', Validators.required],
      c_password: ['', Validators.required],
      phone: ['', Validators.required],
      name: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      agree1: [false, [ Validators.requiredTrue]],
      agree2: [false, Validators.requiredTrue],
    });
  }

  get login() {
    return this.registerForm.get("login");
  }
  get password() {
    return this.registerForm.get("password");
  }
  get c_password() {
    return this.registerForm.get("c_password");
  }
  get phone() {
    return this.registerForm.get("phone");
  }
  get name() {
    return this.registerForm.get("name");
  }
  get surname() {
    return this.registerForm.get("surname");
  }
  get email() {
    return this.registerForm.get("email");
  }

}
